import { sendMessageToServer } from "./serverComs";
import { getAudioGraphInstance } from "./audioEngine";
import store, {
    selectInstruments,
    selectProject,
    updateMetadata,
} from './store';
import { getProjectDataObject } from "./utils/misc";
import { staticSelect } from "./utils/react";

var currentProject = undefined; 

export const getCurrentProject = () => {
    return currentProject;
}

export const setCurrentProject = (project) => {
    currentProject = project;
}

export const instrumentsDisponibles = {};

export const getTipusInstrumentsDisponiblesList = () => {
    const tipusDisponobles = Object.keys(instrumentsDisponibles);
    // Sort by the display name of the instrument
    tipusDisponobles.sort((a, b) => {
        const nomA = instrumentsDisponibles[a].metadata.tipusDisplay;
        const nomB = instrumentsDisponibles[b].metadata.tipusDisplay;
        return nomA.localeCompare(nomB);
    })
    return tipusDisponobles;    
}

export const registerInstrumentDisponible = (instrumentClass) => {
    const tipusInstrument = instrumentClass.metadata.tipus;
    instrumentsDisponibles[tipusInstrument] = instrumentClass;
}

let saveProjectAfterLoad = false;

export const shouldSaveProjectAfterLoad = () => {
    return saveProjectAfterLoad;
}

export const isLocalMode = () => {
    return localMode;
}

let localMode = false;

// Crec que hauriem de canviar una mica això
// Diria que una cosa és la sessió (que sap sobre currentProject, localMode, saveToServer, throttleTime...)
// I una altra cosa és el projecte (que sap el seu id, el seu estat, etc).
export class Project {
    constructor(data, local=false, token=undefined) {
        localMode = local
        this.saveToServerEnabled = true
        this.adminMode = false
        if (token !== undefined) {
            this.adminMode = token === data.token;
        }
        this.continuousControlThrottleTime = 50 // This is mostly for the UI, we also throttle parameter change messages being sent to the server in the server coms file
          
        // Crea objectes per cada instrument i guardal's al projecte. todo: no
        this.instruments = {}
        Object.entries(data.instruments).forEach(([instrumentID, instrumentData]) => this.afegeixInstrument(instrumentID, instrumentData));
    }

    get state() {
        return staticSelect(selectProject);
    }

    getID() {
        return this.state.metadata.id
    }

    getNom() {
        return this.state.metadata.name
    }

    getConnectedUsers() {
        return this.state.metadata.connected_users
    }

    // todo: ?
    getInstrument(instrumentID) {
        return this.instruments[instrumentID];
    }

    // state logic and audio are not separated enough. clunky workaround
    makeDummyInstrument(instrumentID) {
        const tipus = staticSelect(selectInstruments)[instrumentID].tipus;
        return new instrumentsDisponibles[tipus](instrumentID);
    }

    // todo: ?
    getInstrumentsOfType(instrumentType) {
        return Object.values(this.instruments).filter(instrument => instrument.metadata.tipus === instrumentType);
    }
    saveDataInServer() {
        sendMessageToServer('save_project_data', {project_data: getProjectDataObject()});
    }

    saveDataInServerUsingPostRequest(callback) {
        // In local mode we don't have an active web sockets connection, therefore to save the project we can use a post request
        const url = appPrefix + '/save_project_data';
        fetch(url, {
            method: "POST",
            body: JSON.stringify({
                project_id: this.getID(), 
                project_data: getProjectDataObject(),
            }),
            headers: {
                "Content-type": "application/json; charset=UTF-8"
            }
        }).then(response => {
            return response.json()
        }).then(data => {
            callback(data)
        })
        .catch(error => {
            console.error(error);
        });
    }

    // todo: ?
    async afegeixInstrument(instrumentID, instrumentState) {
        
        // Crea l'objecte de l'instrument i l'afegeix al projecte
        const InstrumentClass = instrumentsDisponibles[instrumentState.tipus];
        this.instruments[instrumentID] = new InstrumentClass(instrumentID);
    }

    // todo: ?
    eliminaInstrument(instrumentID) {
        delete this.instruments[instrumentID];
    }

    updateMetadata(name, value) {
        store.dispatch(updateMetadata({ name, value }));
    }

}